import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { XCircleIcon } from '@heroicons/react/24/outline';

const PaymentError: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { error } = location.state || {};

    const handleTryAgain = () => {
        navigate(-1); // Go back to payment page
    };

    const handleContactSupport = () => {
        // You can replace this with your support URL
        window.open('mailto:support@yourapp.com', '_blank');
    };

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white dark:bg-gray-800 py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <div className="text-center">
                        <XCircleIcon className="mx-auto h-12 w-12 text-red-500" />
                        <h2 className="mt-6 text-2xl font-bold text-gray-900 dark:text-white">
                            Payment Failed
                        </h2>
                        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
                            {error || 'There was an error processing your payment.'}
                        </p>
                        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                            Don't worry, your card has not been charged.
                        </p>
                    </div>

                    <div className="mt-6 space-y-3">
                        <button
                            onClick={handleTryAgain}
                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            Try Again
                        </button>
                        <button
                            onClick={handleContactSupport}
                            className="w-full flex justify-center py-2 px-4 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            Contact Support
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentError; 